import React from 'react'
import { Modal, Box, Typography, Button, Stack } from '@mui/material'

export default function BulkRemoveUsersModal({ open, onClose, onConfirm }) {
  return (
    <Modal
      open={open}
      onClose={onClose}
    >
      <Box sx={style}>
        <Typography variant="h3">Confirm Removal</Typography>
        <Typography mb={3}>
          Are you sure you want to remove these contacts from all linked
          clients?
          <br />
          <strong>This action cannot be undone.</strong>
        </Typography>
        <Stack
          direction="row"
          spacing={2}
          justifyContent="flex-end"
        >
          <Button
            variant="outlined"
            onClick={onClose}
            size="large"
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="error"
            size="large"
            onClick={() => {
              onConfirm()
              onClose()
            }}
          >
            Remove
          </Button>
        </Stack>
      </Box>
    </Modal>
  )
}

const style = {
  position: 'absolute',
  top: '40%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '25%',
  minWidth: '300px',
  height: '250px',
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
}
